import React from 'react';

import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {ClientAtom} from '../../../editors/expressions/expressionAtomModel';
import {ExpressionDryRunPill} from '../../../editors/expressions/expressionDryRunPill';
import {getExpressionTypeIcon} from '../../../editors/expressions/expressionIcons';
import {buildAtomDescription} from '../../../editors/expressions/expressionInferHelpers';

/*
 * Props.
 */

interface IconAtomProps {
  atom: ClientAtom;
}

/*
 * Component.
 */

export const AtomIcon = ({atom}: IconAtomProps) => {
  const {name} = buildAtomDescription(atom);

  if (atom.dryRun) {
    return <ExpressionDryRunPill dryRun={atom.dryRun} title={name} />;
  }

  return <Icon name={getExpressionTypeIcon(atom.inferredType).small.filled} />;
};
